import { setupAccordions } from "@/components/content/Accordion"
import { viewItemListEvent } from "@/helpers/ga4_helper"
import { loadBackgroundImages } from "@/helpers/image_loader"

loadBackgroundImages()
setupAccordions()

// TODO[GA4]: Refactor `gift_of_spa` model/decorator so we can populate `items`
viewItemListEvent("Gift of Spa Vouchers", [])
